import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../assets/styles/images/logos/clozesuretools.png";
import "./Header.scss";
import { useAuth, AuthStates } from "../auth/AuthContext";
import UserMenu from "./UserMenu";

const Header = ({ sidebarCollapsed, breadcrumbs }) => {
  const { authState } = useAuth();

  const isAuthenticated = authState === AuthStates.AUTHENTICATED;

  // Logo links to /dashboard if logged in, / if not
  const logoHref = isAuthenticated ? "/dashboard" : "/";

  return (
    <Navbar
      expand="lg"
      className={`custom-navbar ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}
    >
      <Container>
        <Navbar.Brand href={logoHref}>
          <img src={logo} alt="Clozesure" className="logo" />
        </Navbar.Brand>

        {/* Breadcrumbs (only for authenticated users) */}
        {isAuthenticated && breadcrumbs && (
          <nav className="header-breadcrumbs" aria-label="Breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              <span key={crumb.path}>
                {index > 0 && <span className="separator">/</span>}
                {index === breadcrumbs.length - 1 ? (
                  <span className="current">{crumb.label}</span>
                ) : (
                  <a href={crumb.path}>{crumb.label}</a>
                )}
              </span>
            ))}
          </nav>
        )}

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {/* Only show nav links for non-authenticated users */}
          {!isAuthenticated && (
            <Nav className="nav-links">
              <Nav.Link
                href="/promoters"
                className={`nav-text ${
                  window.location.pathname === "/promoters"
                    ? "font-weight-bold text-dark"
                    : ""
                }`}
              >
                Promoters Map
              </Nav.Link>
            </Nav>
          )}
          <UserMenu className="ml-auto" />
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
